module.exports = __webpack_public_path__ + "media/dogs/happy-green-dog-a94fd65c.svg";